'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
var input$1 = require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
require('../../../../styles/styled-components/alert.js');
require('../../../../styles/styled-components/animations.js');
require('../../../../styles/styled-components/box-shadow.js');
require('../../../../styles/styled-components/button.js');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
require('../../../../styles/styled-components/font-face.js');
require('../../../../styles/styled-components/global.js');
var input = require('../../../../styles/styled-components/input.js');
require('../../../../styles/styled-components/list.js');
require('../../../../styles/styled-components/listitem.js');
require('../../../../styles/styled-components/media-queries.js');
require('../../../../styles/styled-components/reset.js');
require('../../../../styles/styled-components/outline.js');
require('../../../../styles/styled-components/popout.js');
require('../../../../styles/styled-components/screen-reader.js');
require('../../../../styles/styled-components/switch.js');
require('../../../../styles/styled-components/tooltip.js');
require('../../../internal/list/standard-list/standard-list.js');
require('../../../internal/listbox/standard-listbox/standard-listbox.js');
require('../../../internal/listitem/standard-listitem/standard-listitem.js');
require('../../../internal/option/standard-option/standard-option.js');
require('../../../internal/textarea/fake-textarea.js');
require('../../../internal/textfield/textfield-addon.js');
var textfieldBody = require('../../../internal/textfield/textfield-body.js');
var textfieldHeader = require('../../../internal/textfield/textfield-header.js');
require('../../../internal/textfield/textfield-icon.js');
require('../../../internal/textfield/textfield-inner.js');
var textfieldWrapper = require('../../../internal/textfield/textfield-wrapper.js');
var baseTextarea = require('../base-textarea/base-textarea.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const BaseStandardTextarea = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { bodyProps , className , disabled , error , errorProps , headerProps , helpText , helpTextProps , id , label , labelPosition , labelProps , look , maxLength , minLength , name , onBlur , onChange , placeholder , readOnly , required , requiredLabel , showLabel , textareaProps , value , wrapperRef , ...otherProps } = props;
    const hasError = !!error;
    const hasHelpText = !!helpText;
    const hasRequired = required && !!requiredLabel;
    const helpTextId = `${id}-help-text`;
    const inlineAlertId = `${id}-inline-alert`;
    return /*#__PURE__*/ React__default.default.createElement(textfieldWrapper.TextfieldWrapper, _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-textarea__standard': true,
            'bf-textarea__standard--disabled': disabled,
            'bf-textarea__standard--error': hasError,
            'bf-textarea__standard--help-text': hasHelpText,
            'bf-textarea__standard--label-hidden': !showLabel,
            [`bf-textarea__standard--label-${labelPosition}`]: showLabel,
            [`bf-textarea__standard--look-${look}`]: look,
            'bf-textarea__standard--placeholder': !!placeholder,
            'bf-textarea__standard--readonly': readOnly,
            'bf-textarea__standard--required': hasRequired,
            [`${className}`]: !!className
        }),
        labelPosition: labelPosition,
        ref: wrapperRef
    }), /*#__PURE__*/ React__default.default.createElement(textfieldHeader.TextfieldHeader, _extends({}, headerProps, {
        className: classnames__default.default({
            'bf-textarea__header': true,
            [`${headerProps?.className}`]: !!headerProps?.className
        }),
        error: error,
        errorProps: errorProps,
        htmlFor: id,
        inlineAlertId: inlineAlertId,
        label: label,
        labelPosition: labelPosition,
        labelProps: labelProps,
        required: required,
        requiredLabel: requiredLabel,
        showLabel: showLabel
    })), /*#__PURE__*/ React__default.default.createElement(textfieldBody.TextfieldBody, _extends({}, bodyProps, {
        className: classnames__default.default({
            'bf-textarea__body': true,
            [`${bodyProps?.className}`]: !!bodyProps?.className
        }),
        error: error,
        errorProps: errorProps,
        helpText: helpText,
        helpTextId: helpTextId,
        helpTextProps: helpTextProps,
        inlineAlertId: inlineAlertId,
        labelPosition: labelPosition
    }), /*#__PURE__*/ React__default.default.createElement(baseTextarea.BaseTextarea, _extends({}, textareaProps, {
        "aria-describedby": hasError ? inlineAlertId : hasHelpText ? helpTextId : undefined,
        "aria-disabled": disabled,
        "aria-invalid": hasError,
        className: classnames__default.default({
            'bf-textarea__textarea': true,
            [`${textareaProps?.className}`]: !!textareaProps?.className
        }),
        disabled: disabled,
        id: id,
        maxLength: maxLength,
        minLength: minLength,
        name: name,
        onBlur: onBlur,
        onChange: onChange,
        placeholder: placeholder,
        readOnly: readOnly,
        ref: ref,
        required: required,
        value: value
    }))));
});
const Textarea = styled__default.default(BaseStandardTextarea)`
  .bf-textarea__textarea {
    ${input.baseInputStyle}
    ${input.getInputBorderRadius({})}
    ${input.getInputPadding({})}
    ${({ error , look  })=>input.getInputTheme({
        error,
        look
    })}
  }
`;
/**
 * A `<textarea>` element, which allows multi-line plain-text editing. `id` and `label` are required for accessibility.
 *
 * When `InputLabelPositions.Left`is set, apply a `width` or `max-width` on `.bf-textfield__header`.
 * See Textfield [examples](https://brandfolder.com/designsystem/?path=/docs/components-molecules-textfields--examples)
 * for recommended CSS styling.
 *
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/textarea
 *
 * @param props StandardTextareaProps
 * @returns FunctionComponent<StandardTextareaProps>
 */ const StandardTextarea = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { labelPosition =input$1.InputLabelPositions.Top , look =input$1.InputLooks.Default , showLabel =true , ...otherProps } = props;
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(Textarea, _extends({}, otherProps, {
        labelPosition: labelPosition,
        look: look,
        ref: ref,
        showLabel: showLabel
    })));
});

exports.StandardTextarea = StandardTextarea;
//# sourceMappingURL=standard-textarea.js.map
